import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { maxValueValidator, minValueValidator } from '@iqd/shared-utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DrawingSessionService } from '../drawing-session.service';
import { CutoutData } from '../shared-drawing-data';

@Component({
  selector: 'hld-add-cutout-modal',
  templateUrl: './add-cutout-modal.component.html',
  styleUrls: ['./add-cutout-modal.component.scss'],
})
export class AddCutoutModalComponent implements OnInit {
  floorData: any;
  private newCutouts: CutoutData[];
  addCutoutForm: FormGroup;
  formErrors: any = {};
  showTransformsWarning: boolean;
  private validationMessages = {
    xDim: {
      required: 'An X Dim is required',
      maxValue: 'X Dim cannot be bigger than X Dim of the floor',
      minValue: 'X Dim cannot be 0 or less',
    },
    yDim: {
      required: 'A Y Dim is required',
      maxValue: 'Y Dim cannot be bigger than Y Dim of the floor',
      minValue: 'Y Dim cannot be 0 or less',
    },
  };

  constructor(
    public activeModal: NgbActiveModal,
    private drawingSessionService: DrawingSessionService
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.addCutoutForm = new FormGroup({
      xDim: new FormControl(3, [
        Validators.required,
        maxValueValidator(this.floorData.GridData.XDim),
        minValueValidator(0.0001),
      ]),
      yDim: new FormControl(2, [
        Validators.required,
        maxValueValidator(this.floorData.GridData.YDim),
        minValueValidator(0.0001),
      ]),
    });
    const tierData = this.floorData.TiersData.TierData;
    for (let i = 0; i < tierData.length; i++) {
      const tierNumber = i + 1;
      this.addCutoutForm.addControl(
        `tier-${tierNumber}`,
        new FormControl(true)
      );
    }
    this.addCutoutForm.valueChanges.subscribe((data) =>
      this.onValueChanged(data)
    );
    this.onValueChanged(); // (re)set validation messages now
  }

  onValueChanged(data?: any): void {
    if (!this.addCutoutForm) {
      return;
    }
    const form = this.addCutoutForm;
    for (const field in this.validationMessages) {
      if (this.validationMessages.hasOwnProperty(field)) {
        // clear previous error message (if any)
        this.formErrors[field] = '';
        const control = form.get(field);
        if (control && control.dirty && !control.valid) {
          const messages = this.validationMessages[field];
          for (const key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              this.formErrors[field] += messages[key] + ' ';
            }
          }
        }
      }
    }
  }

  submitForm(): void {
    const value = this.addCutoutForm.value;
    this.newCutouts = this.drawingSessionService.addNewCutouts(value);
  }

  cancel(): void {
    this.activeModal.close();
  }

  add(): void {
    this.submitForm();
    this.activeModal.close(this.newCutouts);
  }
}
